/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAuthClientSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetAuthClientRequest = {
  /**
   * The auth client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetAuthClientSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const GetAuthClientSecurity$outboundSchema: z.ZodMiniType<
  GetAuthClientSecurity$Outbound,
  GetAuthClientSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function getAuthClientSecurityToJSON(
  getAuthClientSecurity: GetAuthClientSecurity,
): string {
  return JSON.stringify(
    GetAuthClientSecurity$outboundSchema.parse(getAuthClientSecurity),
  );
}

/** @internal */
export type GetAuthClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const GetAuthClientRequest$outboundSchema: z.ZodMiniType<
  GetAuthClientRequest$Outbound,
  GetAuthClientRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function getAuthClientRequestToJSON(
  getAuthClientRequest: GetAuthClientRequest,
): string {
  return JSON.stringify(
    GetAuthClientRequest$outboundSchema.parse(getAuthClientRequest),
  );
}
